import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectAuthData } from '@/containers/Login/AuthSelectors'

import { breakManagementActions } from './breakManagementSagas'
import { selectBreakManagement } from './breakManagementSelectors'
import { clearBreakManagement } from './breakManagementSlice'
import { isBreakManagementAvailable } from './isBreakManagementAvailable'

const useBreakManagementPage = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const authData = useSelector(selectAuthData) as {
    country?: string
    isAdmin?: boolean
    commonData?: { breakManagementEnabled?: boolean }
  }
  const { breakState, error } = useSelector(selectBreakManagement)
  const isAvailable = isBreakManagementAvailable(authData)
  const isAdmin = authData.isAdmin === true

  useEffect(() => {
    if (!isAvailable) return

    dispatch({ type: breakManagementActions.START_POLLING })
    if (isAdmin) dispatch({ type: breakManagementActions.LOAD_SETTINGS })

    return () => {
      dispatch({ type: breakManagementActions.STOP_POLLING })
      dispatch(clearBreakManagement())
    }
  }, [dispatch, isAvailable, isAdmin])

  return {
    t,
    country: authData.country ?? '',
    isAvailable,
    isAdmin,
    isLoading: breakState === null && error === null,
    error,
    currentCount: breakState?.current_count ?? 0,
    max: breakState?.max ?? 0,
  }
}

export default useBreakManagementPage
